import Axios from "axios";
import {
  SET_SALE_ORDER_LIST,
  UNSET_SALE_ORDER_LIST,
} from "@/store/mutation-types";
import { saveUpdateSaleOrder, getSaleOrderList, getSaleOrderById, getSaleOrderProcessById } from "@/store/api";
// initial state
const state = {
  getSaleOrderList: [],
  editingSaleOrder: null,
  viewingSaleOrder: null,
};

const getters = {
  getSaleOrderList(state) {
    return state.getSaleOrderList;
  },
  getEditingSaleOrder: (state) => state.editingSaleOrder,
  getViewingSaleOrder: (state) => state.viewingSaleOrder,
};

const mutations = {
  [SET_SALE_ORDER_LIST](state, data) {
    state.getSaleOrderList = data;
  },
  [UNSET_SALE_ORDER_LIST](state) {
    state.getSaleOrderList = [];
  },
  setEditingSaleOrder(state, lead) {
    state.editingSaleOrder = lead;
  },
  setViewingSaleOrder(state, lead) {
    state.viewingSaleOrder = lead;
  },
};

const actions = {
  saveUpdateSaleOrder({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSaleOrder, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSaleOrderList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSaleOrderList, data)
        .then(function (response) {
          commit("SET_SALE_ORDER_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_SALE_ORDER_LIST");
          reject(error);
        })
        .then((always) => {});
    });
  },

  getSaleOrderById({ commit }, data) {
    const getSaleOrderByIdApi = `${getSaleOrderById}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSaleOrderByIdApi)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("UNSET_SALE_ORDER_LIST");
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSaleOrderProcessById({ commit }, data) {
    const getSaleOrderProcessByIdApi = `${getSaleOrderProcessById}/${data}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getSaleOrderProcessByIdApi)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          commit("UNSET_SALE_ORDER_LIST");
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
